import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ColumnedSection from '../right-pane/columned-section';
import Divider from '@material-ui/core/Divider';
import Typography from 'fuse-ui/components/Typography';

import { formatDate, formatAuthValue } from '../utils/common-utils';

const styles = theme => ( {
    heading: {
        padding: `${theme.spacing.unit}px 0 0`,
    },
    noMargin: {
        margin: `0 -${theme.spacing.unit * 3}px`,
    }
} );

const buildRecordData = ( authType, data ) => {
    const authData = data[authType];
    const { status, record, changeDate } = authData;
    const currentRecordValue = formatAuthValue( status, record );

    const recordDetails = [
        { automationId: `dd-dns-${authType}-record`, title: 'Current Record', value: `${currentRecordValue}` }
    ];

    if( record !== null ){
        recordDetails.push( {
            automationId: `dd-dns-${authType}-last-change`,
            title: 'Last Change',
            value: formatDate( changeDate )
        } );
    }

    return recordDetails;
};

export const DomainDetailsTabDns = ( { classes, dnsData } ) => {
    const hostData = [{ automationId: 'dd-dns-host-name', title: 'Hostname', value: dnsData.domainName }];

    return (
        <>
            <ColumnedSection data={hostData} gutterTop={false} />
            <Divider className={classes.noMargin}/>

            <Typography variant="subtitle1" color="textPrimary" className={classes.heading}>DMARC</Typography>
            <ColumnedSection data={buildRecordData( 'dmarc', dnsData )} />
            <Divider className={classes.noMargin}/>

            <Typography variant="subtitle1" color="textPrimary" className={classes.heading}>SPF</Typography>
            <ColumnedSection data={buildRecordData( 'spf', dnsData )} />
        </>
    );
};

DomainDetailsTabDns.propTypes = {
    classes: PropTypes.object.isRequired,
    dnsData: PropTypes.shape( {
        dmarc: PropTypes.shape( {
            changeDate: PropTypes.string,
            record: PropTypes.string,
        } ),
        domainName: PropTypes.string,
        spf: PropTypes.shape( {
            changeDate: PropTypes.string,
            record: PropTypes.string,
        } ),
    } ),
};

export default withStyles( styles )( DomainDetailsTabDns );
